import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {
  // Este codigo fue generado por Github Copilot Chat
  @Input() loading = false;
  @Input() text = 'Procesando...';
  // Este codigo fue generado por Github Copilot Chat
}
